import { memo } from 'react';
import IncidentsHeaderNav from '../../components/HeadersNav/IncidentsHeaderNav';
import { Outlet } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useSelector } from 'react-redux';

const IncidentsPage = () => {
  const { loadingPermissions } = useSelector(
    (state) => state.nerisSettingsAuthoritiesReducer
  );

  return (
    <>
      {loadingPermissions ? (
        <Box className="w-100 h-100 d-flex justify-content-center align-items-center">
          <CircularProgress />
        </Box>
      ) : (
        <>
          <IncidentsHeaderNav />
          <Outlet />
        </>
      )}
    </>
  );
};

export default memo(IncidentsPage);
